import axios from 'axios'
import userService from './userService'
import { getEnvVar } from '@/assets/js/helpers'

const CancelToken = axios.CancelToken
let cancel

const apiClient = axios.create({
  baseURL: getEnvVar('VUE_APP_API_URL')
})

export default {
  getClubs (data) {
    return apiClient.post(`/clubs/all?debugUser=${userService.debugUserId}`, data, {
      cancelToken: new CancelToken(function executor (c) {
        cancel = c
      })
    })
  },
  cancelGettingClubs () {
    cancel && cancel('canceled')
  },
  getFilters () {
    return apiClient.post('/get-filters')
  }
}
